import { Y_AXIS_DEFAULT_WIDTH } from '@weenat/client/dist/core/charts'
import { DataPoint } from '@weenat/client/dist/core/charts/d3-charts.type'
import { TimeSteps } from '@weenat/client/dist/enums/TimeSteps'
import { FC, ReactNode, Ref } from 'react'
import Chart, { ChartProps } from './Chart'
import Cursor from './Cursor'
import { CursorContext } from './CursorContext'
import Tooltip, { TooltipProps } from './Tooltip'

export type CursorChartProps = ChartProps & {
  data: DataPoint[]
  setDate?: (date: Date | undefined) => void
  renderTooltip?: (dp: DataPoint) => ReactNode
  timeStep: TimeSteps
  isChartRestricted?: boolean
  ref?: Ref<HTMLDivElement>
} & Pick<TooltipProps, 'tooltipWidth' | 'tooltipHeight'>

const CursorChart: FC<CursorChartProps> = ({
  children,
  marginBottom = 32,
  marginLeft = Y_AXIS_DEFAULT_WIDTH,
  marginRight = Y_AXIS_DEFAULT_WIDTH,
  marginTop = 16,
  data,
  renderTooltip,
  tooltipHeight,
  tooltipWidth,
  setDate,
  domain,
  domainPadding,
  width: forcedWidth,
  timeStep,
  isChartRestricted = false,
  ref,
  ...chartProps
}: CursorChartProps) => {
  return (
    <CursorContext
      domainX={domain.x}
      domainPadding={domainPadding}
      width={forcedWidth}
      marginRight={marginRight}
      marginLeft={marginLeft}
      marginBottom={marginBottom}
      marginTop={marginTop}
      data={data}
      setDate={setDate}
      height={chartProps.height}
      containerRef={ref}
    >
      <Chart
        marginBottom={marginBottom}
        marginLeft={marginLeft}
        marginRight={marginRight}
        marginTop={marginTop}
        domain={domain}
        domainPadding={domainPadding}
        width={forcedWidth}
        ref={ref}
        {...chartProps}
      >
        {children}
        <Cursor isChartRestricted={isChartRestricted} />
        <Tooltip
          timeStep={timeStep}
          tooltipHeight={tooltipHeight}
          tooltipWidth={tooltipWidth}
          renderTooltip={renderTooltip}
        />
      </Chart>
    </CursorContext>
  )
}

export default CursorChart
